import React from 'react'
import moment from 'moment'
import NavLink from '../../Routes/NavLink'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { credits } from '../../../core/controllers/Credits'
import { browserHistory } from 'react-router';

export default class PayoutsList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            credits: null,
        };

        this.index = 0;
    }

    componentDidMount() {
        var self = this;
        credits.getCredits(function(response) {
            self.setState({
                credits: response.data.length > 0 ? response.data : null
            })
        });
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    flattenObject(ob) {
        var toReturn = {};
        for (var i in ob) {
            if (!ob.hasOwnProperty(i)) continue;
            if ((typeof ob[i]) == 'object') {
                var flatObject = this.flattenObject(ob[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;
                    toReturn[x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        return toReturn;
    }

    /**
     * Formats money, if not value, return 0
     * @param {*} e
     */
    formatAmount(value) {
        // format money
        var money = parseInt(value) / 100;
        money = Number(money.toFixed(2)).toLocaleString();
        if(money == 'NaN') { money = 0; }

        return money;
    }

    formatMoney(cell, row) {
        return '$' + this.formatAmount(cell);
    }

    didSelectRow(row) {
        browserHistory.push('/tenant/credit/' + row.credit_id); //TODO: change this to correct credit ID
    }

    stopSelectRow(e) {
        e.stopPropagation();
    }

    formatTenant(cell, row) {
        if (row.tenant_id != null) {
            return (
            <span onClick={this}>
                <NavLink to={'/tenant/' + row.tenant_id}>{row.tenant_firstname} {row.tenant_lastname}</NavLink>
            </span>
            )
        }
        return 'No Tenant'
    }

    formatDate(cell, row) {
        if(cell) {
            return moment(cell).format('D MMM YYYY');
        } else {
            return 'Not Set';
        }
    }

    render(){
        var self = this;
        var credits = this.state.credits;

        if (credits != null) {
            credits = credits.map(function(credit) {
                return self.flattenObject(credit);
            });
        }

        const options = {
            onRowClick: this.didSelectRow
        };

        return (
            <div class="row">
                <div class="col-md-12">
                    <div class="content">
                    {credits != null ? (
                        window.innerWidth < 992 ? (
                        <BootstrapTable data={credits} version='4' striped search pagination hover>
                            <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                            <TableHeaderColumn dataField='name' width="150">Name</TableHeaderColumn>
                        </BootstrapTable>
                        ) : (
                        <BootstrapTable data={credits} version='4' striped search pagination hover options={options}>
                            <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                            <TableHeaderColumn dataField='name'>Name</TableHeaderColumn>
                            <TableHeaderColumn dataField='credit' dataFormat={this.formatMoney.bind(this)} >Amount</TableHeaderColumn>
                            <TableHeaderColumn dataField='how_many_months'>Length (months)</TableHeaderColumn>
                            <TableHeaderColumn dataField='tenant_lastname' dataFormat={this.formatTenant.bind(this.stopSelectRow)} >Tenant</TableHeaderColumn>
                            <TableHeaderColumn dataField='created_at' dataFormat={this.formatDate.bind(this)}>Started</TableHeaderColumn>
                        </BootstrapTable>
                        )
                    ) : (
                        <p class="col-md-12">No credits yet.</p>
                    )}
                    </div>
                    <div class="content" style={{float: "right"}}>
                        <NavLink to={"/tenant/credit/new"}>
                            <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off">
                                Create Credit
                            </button>
                            <div class="clearfix"></div>
                        </NavLink>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Tenants/Credits/CreditsList.jsx